import React, { useCallback } from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import PromptRelatedStrip from '@/components/Prompts/PromptRelatedStrip';
import { toolsApi } from '@/lib/api';

/**
 * "Related recipes" grid on the tool detail page — curated Prompt recipes for
 * the same job as this tool. Reuses the prompt grid UI; data comes from
 * `GET /json/tools/:slug/related-prompts` (matched on intentAction/outputType).
 */
function ToolRelatedPrompts({ slug }) {
  const { t } = useTranslation();
  const loadRelated = useCallback((s, opts) => toolsApi.relatedPrompts(s, opts), []);
  return (
    <PromptRelatedStrip
      slug={slug}
      loadRelated={loadRelated}
      title={t('pages.prompts.relatedRecipes') || 'Related recipes'}
      compact
    />
  );
}

export default React.memo(ToolRelatedPrompts);
